import { TooltipWrapper } from "@components";
import {
  createStyles,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Theme,
  withStyles,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import React, { useCallback, useContext } from "react";
import { SELECT_ALL, UNSELECT_ALL, UPDATE_ORDER } from "../state";
import { TableContext } from "../table";
import { ActionColumn } from "../tableWrapper";
import { Cell } from "../types";
import { Order } from "../utils";

const WhiteBackgroundCheckbox = withStyles((theme) => ({
  root: {
    "& .MuiIconButton-label": {
      position: "relative",
      zIndex: 0,
    },
    "&:not($checked) .MuiIconButton-label:after": {
      content: '""',
      left: 4,
      top: 4,
      height: 15,
      width: 15,
      position: "absolute",
      backgroundColor: "white",
      zIndex: -1,
    },
  },
}))(Checkbox);

const StyledTableSortLabel = withStyles((theme: Theme) =>
  createStyles({
    root: {
      color: "white",
      "&:hover": {
        color: "white",
      },
      "&$active": {
        color: "white",
      },
    },
    active: {},
    icon: {
      color: "inherit !important",
      fontSize: "1.5rem",
    },
  })
)(TableSortLabel);

interface Props {
  numSelected: number;
  onSelectAllClick: (event: any) => void;
  order: Order;
  orderBy: number;
  headers: Cell[];
  actions: ActionColumn[];
}

export const Header: React.FC<Props> = ({
  order,
  orderBy,
  headers,
  onSelectAllClick,
  actions,
}) => {
  const isEditable = actions.find((action) => action === "EDIT");
  const isRemovable = actions.find((action) => action === "REMOVE");
  const isExpandable = actions.find((action) => action === "EXPAND");
  const isSelectable = actions.find((action) => action === "SELECT");

  const { state, dispatch } = useContext(TableContext);

  return (
    <TableHead>
      <TableRow>
        {isSelectable ? (
          <TableCell>
            <WhiteBackgroundCheckbox
              checked={!!state.selectAll}
              onClick={onSelectAllClick}
              color="primary"
            />
          </TableCell>
        ) : null}
        {headers.map((header, index) => (
          <TableCell
            key={index}
            align="left"
            sortDirection={orderBy === index ? order : false}
          >
            <StyledTableSortLabel
              active={orderBy === index}
              direction={orderBy === index ? order : "asc"}
              onClick={(event: any) =>
                dispatch({ type: UPDATE_ORDER, orderBy: index })
              }
              IconComponent={ArrowDropUpIcon}
            >
              {header.data}
              {header.tooltip ? (
                <TooltipWrapper title={header.tooltip} placement="right-end" />
              ) : null}
            </StyledTableSortLabel>
          </TableCell>
        ))}
        {isEditable ? <TableCell>Edit</TableCell> : null}
        {isRemovable ? <TableCell>Remove</TableCell> : null}
        {isExpandable ? <TableCell></TableCell> : null}
      </TableRow>
    </TableHead>
  );
};
